import { render, staticRenderFns } from "./Axes.vue?vue&type=template&id=284f8efa&"
import script from "./Axes.vue?vue&type=script&lang=js&"
export * from "./Axes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports